/** h3-6/AD-6 seam: mirrors the BFF's seeded FR16 default until the settings query resolves. */
export const DEFAULT_ORDER_STALENESS_DAYS = 5;

/**
 * h3-5/M3: mirrors the backend's KNOWN_SERVICE_CODES (orders.routes.ts) — the diensten
 * explicitly discussed in the PRD/addendum coverage narrative. No system-wide service-code
 * catalog endpoint exists yet; documented, hardcoded scope boundary on both sides.
 */
export const KNOWN_SERVICE_CODES = ['AANMELDING', 'PACKSHOT', 'PHYSICAL'] as const;
